var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "strategy-text-3-section"
  }, [_c('text-content-wrapper', {
    scopedSlots: _vm._u([{
      key: "col-1",
      fn: function () {
        return [_c('div', {
          staticClass: "lead-1"
        }, [_vm._v(_vm._s(_vm.fields.field_one.value.text))]), _c('div', {
          staticClass: "line-separator"
        })];
      },
      proxy: true
    }, {
      key: "col-2",
      fn: function () {
        return [_c('div', {
          staticClass: "paragraph-1"
        }, [_vm._v(_vm._s(_vm.fields.field_two.value.text))]), _c('ul', _vm._l(_vm.fields.field_two.value.boxes, function (box) {
          return _c('li', [_vm._v(_vm._s(box.name))]);
        }), 0), _c('div', {
          staticClass: "paragraph-1"
        }, [_vm._v(_vm._s(_vm.fields.field_two.value.text2))])];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }